module.exports = __webpack_public_path__ + "static/media/poster-9.fcc192b7.jpg";